<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
    <path
      :style="{ fill: color }"
      d="M64 0a64 64 0 1 0 64 64 64 64 0 0 0-64-64zm0 120.36a56.11 56.11 0 0 1-55.7-48.12 75.61 75.61 0 0 0 27.7-23.07h15a93.6 93.6 0 0 0 67.09 30.62 56.52 56.52 0 0 1-54.09 40.57z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
};
</script>
